<template>
    <List ref="list" :menuMetadataConfigId="menuMetadataConfigId"></List>
</template>

<script>
    import List from '@/views/modules/dyygCollect/library/list'  // 列表
    export default {
        components: {List},
        data() {
            return {
                menuMetadataConfigId: this.$route.meta.menuMetadataConfigId
            }
        },
    }
</script>

<style scoped>

</style>
